// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e697705c","431":"80f438cf","455":"1da1dbbd","977":"1488c4d4"}[chunkId] + ".chunk.js";
};